import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkpaperExport, WorkpaperExportEnum } from '../types/workpaper';
import { AxiosError } from 'axios';

type GetWorkpaperExportResponse = {
    workpaperExport: WorkpaperExport;
};

async function getWorkpaperExport(id?: string): Promise<GetWorkpaperExportResponse> {
    const { data } = await api.get(`/workpapers/${id}/export`);
    return data;
}

export function useWorkpaperExport(id?: string): UseQueryResult<GetWorkpaperExportResponse, AxiosError> {
    return useQuery(['workpaper-export', id], () => getWorkpaperExport(id), {
        keepPreviousData: true,
        refetchInterval: (data) => (data?.workpaperExport.status === WorkpaperExportEnum.EXPORTING ? 5000 : false),
    });
}
